// extracted by mini-css-extract-plugin
module.exports = {"header":"_4a7221a","logoContainer":"_7f63660","btnClose":"_cee9fed","buttonContainer":"_848beba"};